import React, { useState } from "react";
import { Link } from "react-router-dom";
import { all_routes } from "../../router/all_routes";

interface TasksPageMobileProps { }

const TasksPageMobile = (props: TasksPageMobileProps) => {
  const routes = all_routes;
  const [statusFilter, setStatusFilter] = useState('completed');
  const [dueDateFilter, setDueDateFilter] = useState('due-today');
  const [activeTab, setActiveTab] = useState('task');
  const [showDetailsModal, setShowDetailsModal] = useState(false);
  const [selectedTask, setSelectedTask] = useState<any>(null);

  // Sample tasks data with completed tasks
  const allTasks = [
    {
      id: 20990,
      subject: "Approve NOC for Outside Job for user US20990",
      from: "20990",
      date: "Today",
      sentDate: "Jun 27, 2025 by 20990",
      priority: "Medium",
      status: "New",
      completionDate: null,
      dueDate: "25 june 2025"
    },
    {
      id: 20990,
      subject: "Approve NOC for Outside Job for user US20990",
      from: "20990",
      date: "Jun 27, 2025",
      sentDate: "Jun 27, 2025 by 20990",
      priority: "Medium",
      status: "Completed",
      completionDate: "Yesterday",
      dueDate: "25 june 2025"
    }
  ];

  const getFilteredTasks = () => {
    switch (statusFilter) {
      case 'completed':
        return allTasks.filter(task => task.status === 'Completed');
      case 'new-progress':
        return allTasks.filter(task => task.status === 'New' || task.status === 'In Progress');
      case 'all':
        return allTasks;
      default:
        return allTasks.filter(task => task.status === 'Completed');
    }
  };

  const tabItems = [
    { key: 'task', label: 'Task' },
    { key: 'alert', label: 'Alert' },
    { key: 'notifications', label: 'Notifications' },
    { key: 'tracking', label: 'Tracking' }
  ];

  const handleTaskClick = (task: any) => {
    setSelectedTask(task);
    setShowDetailsModal(true);
  };

  const closeModal = () => {
    setShowDetailsModal(false);
    setSelectedTask(null);
  };

  return (
    <div className="page-wrapper mobile-worklist" style={{ backgroundColor: '#f5f5f5', minHeight: '100vh' }}>
      {/* Mobile Header */}
      <div className="bg-danger text-white p-3 d-flex align-items-center">
        <Link to={routes.employeeDashboard} className="text-white me-3">
          <i className="ti ti-arrow-left fs-20"></i>
        </Link>
        <h5 className="mb-0 text-white">To Do Work List</h5>
      </div>

      {/* Tab Navigation */}
      <div className="bg-white border-bottom">
        <div className="d-flex">
          {tabItems.map((tab) => (
            <button
              key={tab.key}
              className={`flex-fill text-center py-3 border-0 bg-transparent ${tab.key === activeTab
                ? 'text-danger fw-medium'
                : 'text-muted'
                }`}
              style={{
                borderBottom: tab.key === activeTab ? '3px solid #dc3545' : '3px solid transparent'
              }}
              onClick={() => setActiveTab(tab.key)}
            >
              {tab.label}
            </button>
          ))}
        </div>
      </div>

      {/* Filter Section */}
      <div className="bg-white p-3 border-bottom">
        <div className="row g-2">
          <div className="col-4">
            <select
              className="form-select form-select-sm"
              value={statusFilter}
              onChange={(e) => setStatusFilter(e.target.value)}
            >
              <option value="completed">Completed Task</option>
              <option value="new-progress">New and in progress Task</option>
              <option value="all">All Tasks</option>
            </select>
          </div>
          <div className="col-4">
            <select
              className="form-select form-select-sm"
              value={dueDateFilter}
              onChange={(e) => setDueDateFilter(e.target.value)}
            >
              <option value="due-today">Due Today</option>
              <option value="this-week">This Week</option>
              <option value="overdue">Overdue</option>
            </select>
          </div>
          <div className="col-4">
            <button className="btn btn-outline-secondary btn-sm w-100">
              <i className="ti ti-filter me-1"></i>
              Filter
            </button>
          </div>
        </div>
      </div>

      {/* Task Cards */}
      <div className="content p-3">
        <div className="row g-3">
          {getFilteredTasks().map((task) => (
            <div key={`${task.id}-${task.status}`} className="col-12">
              <div
                className="card border-0 shadow-sm cursor-pointer hover-card"
                onClick={() => handleTaskClick(task)}
              >
                <div className="card-body p-3">
                  <h6 className="card-title mb-2 fw-medium text-dark">
                    {task.subject}
                  </h6>

                  <div className="d-flex align-items-center text-muted small mb-2">
                    <span className="me-3">{task.id}</span>
                    <span className="me-3">{task.date}</span>
                    <span className="me-3">{task.priority}</span>
                    <i className="ti ti-edit me-1"></i>
                    <span className="me-3">{task.dueDate}</span>
                    <span className={`badge ${task.status === 'Completed' ? 'bg-success' : 'bg-primary'
                      }`}>
                      {task.status}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Empty State */}
        {getFilteredTasks().length === 0 && (
          <div className="text-center py-5">
            <i className="ti ti-inbox fs-48 text-muted mb-3 d-block"></i>
            <h6 className="text-muted">No tasks found</h6>
            <p className="text-muted small">No tasks match your current filters</p>
          </div>
        )}
      </div>

      {/* Task Details Modal */}
      {showDetailsModal && selectedTask && (
        <>
          {/* Backdrop */}
          <div
            className="position-fixed top-0 start-0 w-100 h-100 bg-dark bg-opacity-50"
            style={{ zIndex: 1040 }}
            onClick={closeModal}
          />

          {/* Modal */}
          <div
            className="position-fixed top-0 start-0 w-100 h-100 d-flex flex-column bg-white"
            style={{ zIndex: 1050 }}
          >
            {/* Modal Header */}
            <div className="bg-danger text-white p-3 d-flex align-items-center">
              <button
                className="btn btn-link text-white p-0 me-3"
                onClick={closeModal}
              >
                <i className="ti ti-arrow-left fs-20"></i>
              </button>
              <h5 className="mb-0 text-white">To Do Work List</h5>
            </div>

            {/* Modal Content */}
            <div className="flex-grow-1 p-3">
              <div className="mb-4">
                <h6 className="fw-bold mb-3">{selectedTask.subject}</h6>
              </div>

              <div className="mb-3">
                <div className="d-flex justify-content-between align-items-center py-2 border-bottom">
                  <span className="text-muted">Sent Date :</span>
                  <span className="fw-medium">{selectedTask.sentDate}</span>
                </div>
              </div>

              <div className="mb-3">
                <div className="d-flex justify-content-between align-items-center py-2 border-bottom">
                  <span className="text-muted">Priority :</span>
                  <span className="fw-medium">{selectedTask.priority}</span>
                </div>
              </div>

              {selectedTask.completionDate && (
                <div className="mb-3">
                  <div className="d-flex justify-content-between align-items-center py-2 border-bottom">
                    <span className="text-muted">Completion date :</span>
                    <span className="fw-medium">{selectedTask.completionDate}</span>
                  </div>
                </div>
              )}

              <div className="mb-3">
                <div className="d-flex justify-content-between align-items-center py-2 border-bottom">
                  <span className="text-muted">Status :</span>
                  <span className={`badge ${selectedTask.status === 'Completed' ? 'bg-success' : 'bg-primary'
                    }`}>
                    {selectedTask.status}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </>
      )}

      <style>{`
        .mobile-worklist .cursor-pointer {
          cursor: pointer;
        }
        .mobile-worklist .hover-card:hover {
          transform: translateY(-2px);
          box-shadow: 0 4px 12px rgba(0,0,0,0.15) !important;
        }
        .mobile-worklist .card {
          border-radius: 8px;
          transition: all 0.2s ease;
        }
        .mobile-worklist .form-select-sm {
          font-size: 0.875rem;
        }
      `}</style>
    </div>
  );
};

export default TasksPageMobile;